import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase/app';
import 'firebase/auth';

import store from './store'
import Home from './views/Home.vue'
import Login from './views/Login.vue'
import Food from './views/Food.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/food',
      name: 'food',
      component: Food,
      meta: {
        requiresAuth: true
      }
    }
    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    // }
  ]
})

router.beforeEach((to, from, next) => {
  try {
    if (to.matched.some(record => record.meta.requiresAuth)) {
      var user = store.getters.user;
      if (!user) {
        let fbUser = firebase.auth().currentUser;
        console.log('Commiting FB user', user);
        store.commit('setUser', fbUser);
        user = store.getters.user;
        console.log('Getting user', user);
      }
      if (user) {
        next();
      } else {
        next({ 
          path: '/login',
          params: { nextUrl: to.fullPath } 
        })
      }
    } else {
      next()
    }
  }
  catch(error){
    console.error(error)
  };
});

export default router;
